import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmActionModalComponent } from '../../shared/components/confirm-action-modal';

/**
 * Confirmation modal component used to prompt the user to confirm deletion of a package.
 * @component
 * @selector app-delete-package-modal
 * @example
 *   <app-delete-package-modal [package]="selectedPackage" (close)="handleClose()" (confirm)="handleConfirm($event)"></app-delete-package-modal>
 * @input any package - The package object to be displayed and potentially deleted; used as the payload when confirming deletion.
 * @output EventEmitter<void> close - Emitted when the modal is dismissed or the user cancels the action; carries no payload.
 * @output EventEmitter<any> confirm - Emitted when the user confirms deletion; emits the package object as the event payload.
 *
 * Key methods:
 * - onClose(): void - Closes the modal by emitting the close event.
 * - onConfirm(): void - Confirms deletion by emitting the confirm event with the provided package.
 *
 * Lifecycle hooks:
 * - This component does not implement any Angular lifecycle hooks (e.g., OnInit) and is effectively stateless, delegating actions via outputs.
 */
@Component({
  selector: 'app-delete-package-modal',
  standalone: true,
  imports: [ConfirmActionModalComponent],
  templateUrl: './delete-package-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-package-modal.component.scss'],
})
export class DeletePackageModalComponent {
  @Input() package: any;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<any>();

  onClose(): void {
    this.close.emit();
  }

  onConfirm(): void {
    this.confirm.emit(this.package);
  }
}
